// src/hooks/marketing/usePRMock.js
import { useState, useEffect } from 'react';
import { mockPRData } from '../../mock_data/mock_data/mockPRData';

export const usePRMock = (dateRange) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Simulate API call delay
    const timer = setTimeout(() => {
      setData(mockPRData);
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, [dateRange]);

  const refetch = async () => {
    setRefreshing(true);
    // Simulate refresh delay
    await new Promise(resolve => setTimeout(resolve, 500));
    setData(mockPRData);
    setRefreshing(false);
  };

  return {
    data,
    loading,
    refreshing,
    error,
    refetch,
  };
};